// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detection-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.btn-detect-annotations-large {
  display: block;
  margin: 16px auto 0 auto;
  padding: 12px 32px;
  border: 2px solid var(--button-color, #1976d2);
  border-radius: 8px;
  background: linear-gradient(135deg, var(--button-color, #1976d2), #1565c0);
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.3px;
}

.btn-detect-annotations-large:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-detect-annotations-large:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Tabs (when embedded in AnalysisPreview) */
.detection-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 12px;
  margin-bottom: 12px;
}

.detection-tab {
  background: transparent;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.detection-tab:hover {
  color: #000;
}

.detection-tab.active {
  color: var(--button-color, #1976d2);
  border-bottom-color: var(--button-color, #1976d2);
}

.detection-tab-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}

/* Metadata bar (when embedded in AnalysisPreview) */
.detection-meta-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  padding: 12px 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.detection-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.detection-meta-label {
  color: #666;
  font-weight: 500;
}

.detection-meta-value {
  color: #000;
  font-weight: 600;
}

.detection-meta-value.status-completed {
  color: #2e7d32;
}

.detection-meta-value.status-failed {
  color: #c62828;
}

.detection-meta-value.status-pending,
.detection-meta-value.status-processing,
.detection-meta-value.status-retrying {
  color: #f57c00;
}

/* Header */
.detection-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 30;
}

.detection-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.detection-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #000;
}

.detection-count {
  font-size: 13px;
  color: #666;
}

.detection-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.detection-header-separator {
  width: 1px;
  height: 24px;
  background: #e0e0e0;
  margin: 0 4px;
}

.detection-action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background: transparent;
  border: 1px solid #e0e0e0;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.detection-action-btn:hover {
  border-color: var(--button-color);
  color: var(--button-color);
}

.detection-btn-save {
  background: var(--button-color);
  color: #fff;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.detection-btn-save:hover:not(:disabled) {
  opacity: 0.9;
}

.detection-btn-save:disabled {
  opacity: 0.6;
  cursor: wait;
}

.detection-btn-back {
  background: transparent;
  color: var(--button-color);
  border: 1px solid var(--button-color);
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.detection-btn-back:hover {
  background: var(--button-color);
  color: white;
}

.detection-btn-help {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #999;
  background: transparent;
  color: #666;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.detection-btn-help:hover {
  background: #f0f0f0;
  color: #333;
  border-color: #666;
}

/* Help modal */
.help-modal {
  background: white;
  border-radius: 12px;
  width: 600px;
  max-width: 90vw;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}

.help-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.help-modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.help-modal-body {
  padding: 20px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.help-section {
  margin-bottom: 20px;
}

.help-section:last-child {
  margin-bottom: 0;
}

.help-section h4 {
  margin: 0 0 8px 0;
  font-size: 15px;
  color: #1a1a1a;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}

.help-section p {
  margin: 0 0 8px 0;
}

.help-section ul,
.help-section ol {
  margin: 0;
  padding-left: 20px;
}

.help-section li {
  margin-bottom: 4px;
}

/* Split layout */
.detection-split {
  display: grid;
  grid-template-columns: minmax(400px, 50%) 1fr;
  gap: 16px;
}

/* Image panel */
.detection-image-panel {
  overflow: hidden;
  border-radius: 8px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 8px;
  position: sticky;
  top: 100px;
  align-self: start;
  max-height: calc(100vh - 120px);
}

.detection-image-panel.pan-ready {
  cursor: grab;
}

.detection-image-panel.panning {
  cursor: grabbing;
}

/* Left toolbar (Photoshop-style) */
.detection-toolbar {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  background: #fff;
  border-radius: 8px;
  padding: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.detection-toolbar-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #555;
  font-size: 17px;
  transition: all 0.15s;
  padding: 0;
  line-height: 1;
}

.detection-toolbar-btn:hover {
  background: #f0f0f0;
  color: #333;
}

.detection-toolbar-btn.active {
  background: var(--button-color);
  color: #fff;
}

.detection-toolbar-separator {
  width: 20px;
  height: 1px;
  background: #e0e0e0;
  margin: 3px 0;
}

.detection-toolbar-zoom {
  font-size: 10px;
  color: #999;
  margin-top: 2px;
  -webkit-user-select: none;
          user-select: none;
}

/* Draw options bar (top, visible in draw mode) */
.detection-draw-options {
  position: absolute;
  top: 10px;
  left: 60px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.detection-class-picker {
  display: flex;
  align-items: center;
  gap: 6px;
}

.detection-picker-chip {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.detection-class-picker select {
  font-size: 13px;
  padding: 4px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.detection-btn-process {
  background: var(--button-color);
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.detection-btn-process:hover:not(:disabled) {
  opacity: 0.9;
}

.detection-btn-process:disabled {
  opacity: 0.6;
  cursor: wait;
}

/* Image wrapper */
.detection-image-wrapper {
  position: relative;
  display: inline-block;
  max-width: 100%;
  transition: transform 0.2s ease;
  transform-origin: center center;
}

.detection-image-wrapper.panning {
  transition: none;
}

.detection-image-wrapper img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* SVG overlay */
.detection-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.detection-overlay polygon {
  pointer-events: all;
  cursor: pointer;
  transition: fill 0.15s, stroke-width 0.15s;
}

.detection-overlay.drawing-mode {
  cursor: crosshair;
  pointer-events: all;
}

.detection-overlay.drawing-mode polygon {
  pointer-events: none;
}

.detection-overlay.erase-mode {
  pointer-events: all;
}

.detection-overlay.erase-mode polygon {
  cursor: pointer;
  pointer-events: all;
}

.detection-overlay.erase-mode polygon:hover {
  opacity: 0.5;
  stroke-dasharray: 4 2;
}

.detection-overlay.pair-mode {
  pointer-events: all;
}

.detection-overlay.pair-mode polygon {
  pointer-events: all;
  cursor: pointer;
  transition: fill 0.15s, stroke-width 0.15s, opacity 0.15s;
}

.detection-overlay.pan-mode {
  pointer-events: none;
}

.detection-overlay.pan-mode polygon {
  pointer-events: none;
}

.detection-pending-remove {
  pointer-events: all;
  cursor: pointer;
}

/* Crop preview (fixed top-right, colored border) */
.detection-crop-preview {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 20;
  width: 280px;
  background: rgba(255, 255, 255, 0.7);
  border: 3px solid #ccc;
  border-radius: 8px;
  padding: 4px;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(2px);
  animation: fadeIn 0.15s ease;
}

.detection-crop-preview img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Values panel */
.detection-values-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 4px;
}

.detection-class-group {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.detection-class-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fafafa;
  font-weight: 600;
  font-size: 14px;
  border-left: 3px solid #ccc;
}

.detection-color-chip {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
}

.detection-class-name {
  flex: 1 1;
}

.detection-class-count {
  background: #f5f5f5;
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 500;
  color: #888;
}

/* Items */
.detection-items {
  display: flex;
  flex-direction: column;
}

.detection-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  transition: background 0.15s;
  cursor: default;
  position: relative;
}

.detection-item.hovered {
  background: #e8f4ff;
}

.detection-class-select {
  font-size: 11px;
  color: #666;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 2px 4px;
  margin-top: 2px;
  cursor: pointer;
  max-width: 100px;
  flex-shrink: 0;
  transition: border-color 0.2s ease;
}

.detection-class-select:hover,
.detection-class-select:focus {
  border-color: var(--button-color);
  outline: none;
  background: #fff;
}

.detection-item-fields {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  flex-wrap: wrap;
  min-width: 0;
}

.detection-inline-input {
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 15px;
  font-weight: 600;
  color: #000;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 2px 6px;
  width: 100px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.detection-inline-input:focus {
  outline: none;
  border-color: var(--button-color);
  background: #fff;
}

.detection-inline-input:hover:not(:focus) {
  border-color: #e0e0e0;
}

.detection-inline-input.tolerance {
  width: 70px;
  font-size: 13px;
  font-weight: 500;
  color: #444;
}

.detection-add-field {
  background: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.detection-add-field:hover {
  border-color: var(--button-color);
  color: var(--button-color);
}

.detection-remove-field {
  background: transparent;
  border: none;
  font-size: 16px;
  color: #ccc;
  cursor: pointer;
  padding: 0 2px;
  flex-shrink: 0;
  transition: color 0.2s ease;
}

.detection-remove-field:hover {
  color: #e74c3c;
}

.detection-inline-input.extra-label {
  width: 60px;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-family: inherit;
}

.detection-delete-item {
  background: transparent;
  border: none;
  font-size: 16px;
  color: #ccc;
  cursor: pointer;
  padding: 0 4px;
  flex-shrink: 0;
  line-height: 1;
  transition: color 0.15s;
}

.detection-delete-item:hover {
  color: #e74c3c;
}

.detection-confidence {
  background: #f5f5f5;
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 11px;
  color: #999;
  font-weight: 500;
}

.detection-error {
  color: #e67e22;
  font-size: 14px;
}

/* Notes wide input */
.detection-item-fields.notes-fields {
  flex-direction: column;
  align-items: stretch;
}

.detection-inline-input.notes-value {
  width: 100%;
  min-height: 48px;
  resize: vertical;
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  padding: 6px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fafafa;
  color: #333;
}

.detection-inline-input.notes-value:focus {
  outline: none;
  border-color: var(--button-color);
  background: #fff;
}

/* Role pills (EXT/INT) */
.detection-role-pills {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
  margin-top: 2px;
}

.detection-role-pill {
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: transparent;
  color: #999;
  cursor: pointer;
  transition: all 0.15s;
  line-height: 1.4;
}

.detection-role-pill:hover {
  border-color: #999;
  color: #666;
}

.detection-role-pill.active.ext {
  background: #2196F3;
  color: white;
  border-color: #2196F3;
}

.detection-role-pill.active.int {
  background: #FF9800;
  color: white;
  border-color: #FF9800;
}

.detection-role-pill.active.n {
  background: #9C27B0;
  color: white;
  border-color: #9C27B0;
}

.detection-n-input {
  width: 36px;
  padding: 1px 4px;
  font-size: 10px;
  font-weight: 600;
  border: 1px solid #9C27B0;
  border-radius: 3px;
  color: #9C27B0;
  text-align: center;
  outline: none;
}

.detection-n-input::placeholder {
  color: #CE93D8;
}

.detection-n-input:focus {
  background: #F3E5F5;
}

/* Manual badge */
.detection-manual-badge {
  background: #f0f0f0;
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 11px;
  color: #888;
  font-weight: 500;
  font-style: italic;
}

/* Report button (prominent) */
.detection-btn-report {
  display: flex;
  align-items: center;
  gap: 5px;
  background: #217346;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.detection-btn-report:hover:not(:disabled) {
  background: #1a5c38;
}

.detection-btn-report:disabled {
  opacity: 0.6;
  cursor: wait;
}

/* Report progress modal */
.report-modal {
  background: white;
  border-radius: 12px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.report-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 12px;
}

.report-modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.report-modal-steps {
  padding: 8px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.report-step {
  display: flex;
  align-items: center;
  gap: 12px;
  transition: opacity 0.3s ease;
}

.report-step.pending {
  opacity: 0.35;
}

.report-step.active {
  opacity: 1;
}

.report-step.completed {
  opacity: 0.7;
}

.report-step-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  background: #f0f0f0;
  color: #999;
  transition: all 0.3s ease;
}

.report-step.active .report-step-icon {
  background: var(--button-color, #007bff);
  color: #fff;
}

.report-step.completed .report-step-icon {
  background: #217346;
  color: #fff;
}

.report-step-label {
  font-size: 14px;
  color: #333;
}

.report-step.pending .report-step-label {
  color: #aaa;
}

.report-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: reportSpin 0.8s linear infinite;
}

@keyframes reportSpin {
  to { transform: rotate(360deg); }
}

.report-modal-success {
  padding: 12px 24px 20px;
  font-size: 14px;
  color: #217346;
  font-weight: 500;
  text-align: center;
}

.report-modal-error {
  padding: 12px 24px 20px;
  font-size: 14px;
  color: #e74c3c;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.report-modal-retry {
  background: transparent;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.report-modal-retry:hover {
  background: #e74c3c;
  color: #fff;
}

/* Pair mode */
.detection-item.pair-selected {
  border-left: 3px solid #2196F3;
  background: #e3f2fd;
}

.detection-item.pair-candidate {
  cursor: pointer;
}

.detection-item.pair-candidate:hover {
  background: #e8f4ff;
}

.detection-item.pair-chosen {
  background: #e3f2fd;
  border-left: 3px solid #4CAF50;
}

.detection-item.pair-dimmed {
  opacity: 0.4;
  pointer-events: none;
}

.detection-paired-badge {
  background: #e3f2fd;
  color: #1565C0;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 4px 2px 6px;
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.detection-paired-remove {
  background: transparent;
  border: none;
  color: #90CAF9;
  font-size: 13px;
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
  transition: color 0.15s;
}

.detection-paired-remove:hover {
  color: #e74c3c;
}

.detection-linked-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2196F3;
  flex-shrink: 0;
}

.detection-pair-summary {
  position: absolute;
  top: 10px;
  left: 60px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.detection-pair-confirm {
  background: #4CAF50;
  color: #fff;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.detection-pair-confirm:hover {
  background: #388E3C;
}

.detection-pair-cancel {
  background: transparent;
  border: none;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  padding: 0 4px;
}

.detection-pair-cancel:hover {
  color: #e74c3c;
}

@media (max-width: 768px) {
  .detection-split {
    grid-template-columns: 1fr;
  }
}

/* NUBBI-94 — Matches detección ↔ operaciones */
.detection-filter-bar {
  display: flex;
  justify-content: flex-end;
  padding: 6px 10px;
  border-bottom: 1px solid #eee;
  background: #fafafa;
}
.detection-filter-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #555;
  cursor: pointer;
}
.detection-filter-toggle input { margin: 0; }

.detection-unmatched-badge {
  display: inline-block;
  padding: 2px 8px;
  background: #e0e0e0;
  color: #555;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.detection-matches-wrapper {
  flex-basis: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #ddd;
}
.detection-match-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 10px;
  background: #f1f6ff;
  border: 1px solid #c9dbf5;
  border-left: 3px solid #2a5cdb;
  border-radius: 4px;
  font-size: 11px;
}
.detection-match-block-empty { background: #fafafa; border-color: #eee; border-left-color: #aaa; }
.detection-match-header { display: flex; align-items: center; gap: 8px; }
.detection-match-op { font-weight: 600; color: #1a3a8b; }
.detection-match-page { font-size: 10px; color: #777; }
.detection-match-params { display: flex; flex-wrap: wrap; gap: 6px 10px; }
.detection-match-param { display: inline-flex; gap: 4px; color: #444; }
.detection-match-param-label { color: #888; }
.detection-match-param-value { font-weight: 500; color: #222; }
.detection-match-param-highlighted {
  background: #fff4b8;
  padding: 1px 6px;
  border-radius: 3px;
  font-weight: 700;
  color: #5a4400;
}
.detection-match-param-highlighted .detection-match-param-label { color: #6e5500; }
.detection-match-param-highlighted .detection-match-param-value { color: #4a3500; }

/* NUBBI-94 — Toggle en pestaña Operaciones */
.operations-summary-bar {
  display: flex;
  justify-content: flex-end;
  padding: 6px 10px;
  margin-bottom: 8px;
  border-bottom: 1px solid #eee;
}
.operations-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #555;
  cursor: pointer;
}
.operations-toggle input { margin: 0; }

/* NUBBI-94 v2 — Mejora visual sub-bloques matches */
.detection-item {
  flex-wrap: wrap;
  row-gap: 8px;
}

.detection-unmatched-pill,
.detection-matched-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2px;
  white-space: nowrap;
}
.detection-unmatched-pill {
  background: #f4f4f6;
  color: #888;
  border: 1px solid #e3e3e7;
}
.detection-unmatched-pill .dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #bbb;
}
.detection-matched-pill {
  background: #e7f5ec;
  color: #1f7a44;
  border: 1px solid #bfe3cc;
}

.detection-matches-stack {
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 4px 0 4px 24px;
  padding-left: 12px;
  border-left: 2px solid #e0e6f2;
}

.match-card {
  background: #fbfcfe;
  border: 1px solid #e4e9f2;
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: border-color 0.15s ease;
}
.match-card:hover { border-color: #b8c5dc; }
.match-card-empty { background: #fafafa; color: #888; }

.match-card-header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 11px;
}
.match-category {
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #2a5cdb;
  font-size: 11px;
}
.match-subpath { color: #6a7796; font-weight: 500; font-size: 11px; }
.match-index {
  margin-left: auto;
  color: #98a2b8;
  font-size: 10px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  background: #eef1f7;
  padding: 1px 6px;
  border-radius: 8px;
}

.match-card-params {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 6px;
}
.match-param-chip {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 5px 8px;
  background: #ffffff;
  border: 1px solid #e8ecf3;
  border-radius: 4px;
  min-width: 0;
}
.match-param-key {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #8a93a8;
  font-weight: 600;
}
.match-param-value {
  font-size: 13px;
  font-weight: 600;
  color: #1a1f2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.match-param-chip.is-highlighted {
  background: linear-gradient(180deg, #fff7c2 0%, #ffefa0 100%);
  border-color: #f0d564;
  box-shadow: 0 1px 2px rgba(214, 178, 22, 0.18);
}
.match-param-chip.is-highlighted .match-param-key { color: #7c5a00; }
.match-param-chip.is-highlighted .match-param-value { color: #463100; }

/* NUBBI-94 — Edición manual de matches */
.detection-assign-btn,
.detection-edit-match-btn,
.detection-clear-override-btn {
  background: none;
  border: 1px solid #d4d9e3;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 11px;
  cursor: pointer;
  color: #4a5470;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}
.detection-assign-btn:hover,
.detection-edit-match-btn:hover,
.detection-clear-override-btn:hover {
  background: #f1f5fb;
  border-color: #2a5cdb;
  color: #2a5cdb;
}
.detection-match-editor-wrapper {
  flex-basis: 100%;
  margin-top: 6px;
}
.match-editor {
  background: #fff;
  border: 1px solid #b8c5dc;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 0 2px 6px rgba(30, 60, 120, 0.08);
}
.match-editor-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}
.match-editor-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  color: #5a6580;
}
.match-editor-field > span {
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 0.4px;
  font-weight: 600;
  color: #6e7891;
}
.match-editor-field select {
  padding: 5px 8px;
  border: 1px solid #d4d9e3;
  border-radius: 4px;
  background: #fafbfd;
  font-size: 12px;
  color: #1a1f2e;
  cursor: pointer;
}
.match-editor-field select:focus {
  outline: none;
  border-color: #2a5cdb;
  background: white;
}
.match-editor-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.match-editor-save,
.match-editor-cancel {
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
}
.match-editor-save { background: #2a5cdb; color: white; }
.match-editor-save:hover:not(:disabled) { background: #1a4cc0; }
.match-editor-save:disabled { background: #c0c8d8; cursor: not-allowed; }
.match-editor-cancel { background: white; color: #5a6580; border-color: #d4d9e3; }
.match-editor-cancel:hover { background: #f1f5fb; color: #2a5cdb; }

/* NUBBI-94 — Editor formulario (rev) */
.match-editor-headrow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}
.match-editor-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 6px 0;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a93a8;
  font-weight: 600;
}
.match-editor-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: #e4e9f2;
}
.match-editor-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}
.match-editor-field input[type="text"],
.match-editor-field input[type="number"] {
  padding: 5px 8px;
  border: 1px solid #d4d9e3;
  border-radius: 4px;
  background: #fff;
  font-size: 12px;
  color: #1a1f2e;
}
.match-editor-field input:focus {
  outline: none;
  border-color: #2a5cdb;
}
.match-editor-field.is-auto input {
  background: linear-gradient(180deg, #fff7c2 0%, #ffefa0 100%);
  border-color: #f0d564;
  font-weight: 600;
}
.match-editor-field.is-auto > span {
  color: #7c5a00;
}
.match-editor-field input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 4px 0;
}

/* NUBBI-94 — Click en card + X rechazar match */
.match-card.is-clickable { cursor: pointer; }
.match-card.is-clickable:hover {
  border-color: #2a5cdb;
  box-shadow: 0 2px 5px rgba(42, 92, 219, 0.15);
}
.match-card-header { position: relative; }
.match-card-close {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #d4d9e3;
  background: #fff;
  color: #888;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.match-card-close:hover {
  background: #fee;
  border-color: #d44;
  color: #c33;
}

/* NUBBI-94 — Autosave indicator */
.detection-autosave-status {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
  min-width: 90px;
  text-align: center;
  letter-spacing: 0.2px;
}
.detection-autosave-status.status-saving { color: #1976d2; background: #e3f2fd; }
.detection-autosave-status.status-ok { color: #2e7d32; background: #e8f5e9; }
.detection-autosave-status.status-dirty { color: #b26a00; background: #fff4e0; }
.detection-autosave-status.status-error { color: #c33; background: #fee; cursor: default; }
.detection-autosave-status.status-idle { display: none; }
`, "",{"version":3,"sources":["webpack://./src/components/History/DetectionView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,0EAA0E;EAC1E,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,6CAA6C;EAC7C,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;;EAEE,iCAAiC;EACjC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA,iCAAiC,SAAS,EAAE;;AAE5C;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;AACA,+BAA+B,mBAAmB,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AACjG,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACxE,sBAAsB,gBAAgB,EAAE,cAAc,EAAE;AACxD,wBAAwB,eAAe,EAAE,WAAW,EAAE;AACtD,0BAA0B,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE;AACzE,yBAAyB,oBAAoB,EAAE,QAAQ,EAAE,WAAW,EAAE;AACtE,+BAA+B,WAAW,EAAE;AAC5C,+BAA+B,gBAAgB,EAAE,WAAW,EAAE;AAC9D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA,kEAAkE,cAAc,EAAE;AAClF,kEAAkE,cAAc,EAAE;;AAElF,6CAA6C;AAC7C;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA,2BAA2B,SAAS,EAAE;;AAEtC,oDAAoD;AACpD;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;AACrC;AACA,oBAAoB,qBAAqB,EAAE;AAC3C,oBAAoB,mBAAmB,EAAE,WAAW,EAAE;;AAEtD;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;AACA,iBAAiB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACpE;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,2DAA2D;EAC3D,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,8CAA8C;AAChD;AACA,oDAAoD,cAAc,EAAE;AACpE,sDAAsD,cAAc,EAAE;;AAEtE,yCAAyC;AACzC;;;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;AACA,qBAAqB,mBAAmB,EAAE,YAAY,EAAE;AACxD,0CAA0C,mBAAmB,EAAE;AAC/D,8BAA8B,mBAAmB,EAAE,mBAAmB,EAAE;AACxE,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACjF,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE,uCAAuC;AACvC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,gDAAgD;AAChD,2BAA2B,eAAe,EAAE;AAC5C;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,qBAAqB,kBAAkB,EAAE;AACzC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA,2CAA2C,cAAc,EAAE,mBAAmB,EAAE;AAChF,uCAAuC,cAAc,EAAE,mBAAmB,EAAE;AAC5E,0CAA0C,cAAc,EAAE,mBAAmB,EAAE;AAC/E,0CAA0C,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC1F,yCAAyC,aAAa,EAAE","sourcesContent":[".detection-view {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.btn-detect-annotations-large {\n  display: block;\n  margin: 16px auto 0 auto;\n  padding: 12px 32px;\n  border: 2px solid var(--button-color, #1976d2);\n  border-radius: 8px;\n  background: linear-gradient(135deg, var(--button-color, #1976d2), #1565c0);\n  color: white;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  letter-spacing: 0.3px;\n}\n\n.btn-detect-annotations-large:hover:not(:disabled) {\n  opacity: 0.92;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.btn-detect-annotations-large:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Tabs (when embedded in AnalysisPreview) */\n.detection-tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid #e0e0e0;\n  padding: 0 12px;\n  margin-bottom: 12px;\n}\n\n.detection-tab {\n  background: transparent;\n  border: none;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #666;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.detection-tab:hover {\n  color: #000;\n}\n\n.detection-tab.active {\n  color: var(--button-color, #1976d2);\n  border-bottom-color: var(--button-color, #1976d2);\n}\n\n.detection-tab-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n/* Metadata bar (when embedded in AnalysisPreview) */\n.detection-meta-bar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 24px;\n  padding: 12px 24px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.detection-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.detection-meta-label {\n  color: #666;\n  font-weight: 500;\n}\n\n.detection-meta-value {\n  color: #000;\n  font-weight: 600;\n}\n\n.detection-meta-value.status-completed {\n  color: #2e7d32;\n}\n\n.detection-meta-value.status-failed {\n  color: #c62828;\n}\n\n.detection-meta-value.status-pending,\n.detection-meta-value.status-processing,\n.detection-meta-value.status-retrying {\n  color: #f57c00;\n}\n\n/* Header */\n.detection-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 30;\n}\n\n.detection-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.detection-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #000;\n}\n\n.detection-count {\n  font-size: 13px;\n  color: #666;\n}\n\n.detection-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.detection-header-separator {\n  width: 1px;\n  height: 24px;\n  background: #e0e0e0;\n  margin: 0 4px;\n}\n\n.detection-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: transparent;\n  border: 1px solid #e0e0e0;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #555;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.detection-action-btn:hover {\n  border-color: var(--button-color);\n  color: var(--button-color);\n}\n\n.detection-btn-save {\n  background: var(--button-color);\n  color: #fff;\n  border: none;\n  padding: 8px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.detection-btn-save:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.detection-btn-save:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n.detection-btn-back {\n  background: transparent;\n  color: var(--button-color);\n  border: 1px solid var(--button-color);\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.detection-btn-back:hover {\n  background: var(--button-color);\n  color: white;\n}\n\n.detection-btn-help {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #999;\n  background: transparent;\n  color: #666;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.detection-btn-help:hover {\n  background: #f0f0f0;\n  color: #333;\n  border-color: #666;\n}\n\n/* Help modal */\n.help-modal {\n  background: white;\n  border-radius: 12px;\n  width: 600px;\n  max-width: 90vw;\n  max-height: 80vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.3);\n}\n\n.help-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.help-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.help-modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #333;\n}\n\n.help-section {\n  margin-bottom: 20px;\n}\n\n.help-section:last-child {\n  margin-bottom: 0;\n}\n\n.help-section h4 {\n  margin: 0 0 8px 0;\n  font-size: 15px;\n  color: #1a1a1a;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 4px;\n}\n\n.help-section p {\n  margin: 0 0 8px 0;\n}\n\n.help-section ul,\n.help-section ol {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.help-section li {\n  margin-bottom: 4px;\n}\n\n/* Split layout */\n.detection-split {\n  display: grid;\n  grid-template-columns: minmax(400px, 50%) 1fr;\n  gap: 16px;\n}\n\n/* Image panel */\n.detection-image-panel {\n  overflow: hidden;\n  border-radius: 8px;\n  background: #fafafa;\n  border: 1px solid #e0e0e0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 8px;\n  position: sticky;\n  top: 100px;\n  align-self: start;\n  max-height: calc(100vh - 120px);\n}\n\n.detection-image-panel.pan-ready {\n  cursor: grab;\n}\n\n.detection-image-panel.panning {\n  cursor: grabbing;\n}\n\n/* Left toolbar (Photoshop-style) */\n.detection-toolbar {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  background: #fff;\n  border-radius: 8px;\n  padding: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.detection-toolbar-btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #555;\n  font-size: 17px;\n  transition: all 0.15s;\n  padding: 0;\n  line-height: 1;\n}\n\n.detection-toolbar-btn:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.detection-toolbar-btn.active {\n  background: var(--button-color);\n  color: #fff;\n}\n\n.detection-toolbar-separator {\n  width: 20px;\n  height: 1px;\n  background: #e0e0e0;\n  margin: 3px 0;\n}\n\n.detection-toolbar-zoom {\n  font-size: 10px;\n  color: #999;\n  margin-top: 2px;\n  user-select: none;\n}\n\n/* Draw options bar (top, visible in draw mode) */\n.detection-draw-options {\n  position: absolute;\n  top: 10px;\n  left: 60px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 12px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.detection-class-picker {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.detection-picker-chip {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  flex-shrink: 0;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n}\n\n.detection-class-picker select {\n  font-size: 13px;\n  padding: 4px 8px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.detection-btn-process {\n  background: var(--button-color);\n  color: #fff;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.detection-btn-process:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.detection-btn-process:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n/* Image wrapper */\n.detection-image-wrapper {\n  position: relative;\n  display: inline-block;\n  max-width: 100%;\n  transition: transform 0.2s ease;\n  transform-origin: center center;\n}\n\n.detection-image-wrapper.panning {\n  transition: none;\n}\n\n.detection-image-wrapper img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n/* SVG overlay */\n.detection-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.detection-overlay polygon {\n  pointer-events: all;\n  cursor: pointer;\n  transition: fill 0.15s, stroke-width 0.15s;\n}\n\n.detection-overlay.drawing-mode {\n  cursor: crosshair;\n  pointer-events: all;\n}\n\n.detection-overlay.drawing-mode polygon {\n  pointer-events: none;\n}\n\n.detection-overlay.erase-mode {\n  pointer-events: all;\n}\n\n.detection-overlay.erase-mode polygon {\n  cursor: pointer;\n  pointer-events: all;\n}\n\n.detection-overlay.erase-mode polygon:hover {\n  opacity: 0.5;\n  stroke-dasharray: 4 2;\n}\n\n.detection-overlay.pair-mode {\n  pointer-events: all;\n}\n\n.detection-overlay.pair-mode polygon {\n  pointer-events: all;\n  cursor: pointer;\n  transition: fill 0.15s, stroke-width 0.15s, opacity 0.15s;\n}\n\n.detection-overlay.pan-mode {\n  pointer-events: none;\n}\n\n.detection-overlay.pan-mode polygon {\n  pointer-events: none;\n}\n\n.detection-pending-remove {\n  pointer-events: all;\n  cursor: pointer;\n}\n\n/* Crop preview (fixed top-right, colored border) */\n.detection-crop-preview {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 20;\n  width: 280px;\n  background: rgba(255, 255, 255, 0.7);\n  border: 3px solid #ccc;\n  border-radius: 8px;\n  padding: 4px;\n  pointer-events: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  backdrop-filter: blur(2px);\n  animation: fadeIn 0.15s ease;\n}\n\n.detection-crop-preview img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Values panel */\n.detection-values-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-right: 4px;\n}\n\n.detection-class-group {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.detection-class-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #fafafa;\n  font-weight: 600;\n  font-size: 14px;\n  border-left: 3px solid #ccc;\n}\n\n.detection-color-chip {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.detection-class-name {\n  flex: 1;\n}\n\n.detection-class-count {\n  background: #f5f5f5;\n  border-radius: 10px;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #888;\n}\n\n/* Items */\n.detection-items {\n  display: flex;\n  flex-direction: column;\n}\n\n.detection-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #f0f0f0;\n  transition: background 0.15s;\n  cursor: default;\n  position: relative;\n}\n\n.detection-item.hovered {\n  background: #e8f4ff;\n}\n\n.detection-class-select {\n  font-size: 11px;\n  color: #666;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  padding: 2px 4px;\n  margin-top: 2px;\n  cursor: pointer;\n  max-width: 100px;\n  flex-shrink: 0;\n  transition: border-color 0.2s ease;\n}\n\n.detection-class-select:hover,\n.detection-class-select:focus {\n  border-color: var(--button-color);\n  outline: none;\n  background: #fff;\n}\n\n.detection-item-fields {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.detection-inline-input {\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  font-size: 15px;\n  font-weight: 600;\n  color: #000;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  padding: 2px 6px;\n  width: 100px;\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.detection-inline-input:focus {\n  outline: none;\n  border-color: var(--button-color);\n  background: #fff;\n}\n\n.detection-inline-input:hover:not(:focus) {\n  border-color: #e0e0e0;\n}\n\n.detection-inline-input.tolerance {\n  width: 70px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #444;\n}\n\n.detection-add-field {\n  background: transparent;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  width: 24px;\n  height: 24px;\n  font-size: 16px;\n  color: #999;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n}\n\n.detection-add-field:hover {\n  border-color: var(--button-color);\n  color: var(--button-color);\n}\n\n.detection-remove-field {\n  background: transparent;\n  border: none;\n  font-size: 16px;\n  color: #ccc;\n  cursor: pointer;\n  padding: 0 2px;\n  flex-shrink: 0;\n  transition: color 0.2s ease;\n}\n\n.detection-remove-field:hover {\n  color: #e74c3c;\n}\n\n.detection-inline-input.extra-label {\n  width: 60px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  font-family: inherit;\n}\n\n.detection-delete-item {\n  background: transparent;\n  border: none;\n  font-size: 16px;\n  color: #ccc;\n  cursor: pointer;\n  padding: 0 4px;\n  flex-shrink: 0;\n  line-height: 1;\n  transition: color 0.15s;\n}\n\n.detection-delete-item:hover {\n  color: #e74c3c;\n}\n\n.detection-confidence {\n  background: #f5f5f5;\n  border-radius: 10px;\n  padding: 2px 8px;\n  font-size: 11px;\n  color: #999;\n  font-weight: 500;\n}\n\n.detection-error {\n  color: #e67e22;\n  font-size: 14px;\n}\n\n/* Notes wide input */\n.detection-item-fields.notes-fields {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.detection-inline-input.notes-value {\n  width: 100%;\n  min-height: 48px;\n  resize: vertical;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.4;\n  padding: 6px 8px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background: #fafafa;\n  color: #333;\n}\n\n.detection-inline-input.notes-value:focus {\n  outline: none;\n  border-color: var(--button-color);\n  background: #fff;\n}\n\n/* Role pills (EXT/INT) */\n.detection-role-pills {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.detection-role-pill {\n  padding: 1px 6px;\n  font-size: 10px;\n  font-weight: 600;\n  border-radius: 3px;\n  border: 1px solid #ccc;\n  background: transparent;\n  color: #999;\n  cursor: pointer;\n  transition: all 0.15s;\n  line-height: 1.4;\n}\n\n.detection-role-pill:hover {\n  border-color: #999;\n  color: #666;\n}\n\n.detection-role-pill.active.ext {\n  background: #2196F3;\n  color: white;\n  border-color: #2196F3;\n}\n\n.detection-role-pill.active.int {\n  background: #FF9800;\n  color: white;\n  border-color: #FF9800;\n}\n\n.detection-role-pill.active.n {\n  background: #9C27B0;\n  color: white;\n  border-color: #9C27B0;\n}\n\n.detection-n-input {\n  width: 36px;\n  padding: 1px 4px;\n  font-size: 10px;\n  font-weight: 600;\n  border: 1px solid #9C27B0;\n  border-radius: 3px;\n  color: #9C27B0;\n  text-align: center;\n  outline: none;\n}\n\n.detection-n-input::placeholder {\n  color: #CE93D8;\n}\n\n.detection-n-input:focus {\n  background: #F3E5F5;\n}\n\n/* Manual badge */\n.detection-manual-badge {\n  background: #f0f0f0;\n  border-radius: 10px;\n  padding: 2px 8px;\n  font-size: 11px;\n  color: #888;\n  font-weight: 500;\n  font-style: italic;\n}\n\n/* Report button (prominent) */\n.detection-btn-report {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: #217346;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.detection-btn-report:hover:not(:disabled) {\n  background: #1a5c38;\n}\n\n.detection-btn-report:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n/* Report progress modal */\n.report-modal {\n  background: white;\n  border-radius: 12px;\n  width: 400px;\n  max-width: 90vw;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n}\n\n.report-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px 12px;\n}\n\n.report-modal-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.report-modal-steps {\n  padding: 8px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.report-step {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: opacity 0.3s ease;\n}\n\n.report-step.pending {\n  opacity: 0.35;\n}\n\n.report-step.active {\n  opacity: 1;\n}\n\n.report-step.completed {\n  opacity: 0.7;\n}\n\n.report-step-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n  background: #f0f0f0;\n  color: #999;\n  transition: all 0.3s ease;\n}\n\n.report-step.active .report-step-icon {\n  background: var(--button-color, #007bff);\n  color: #fff;\n}\n\n.report-step.completed .report-step-icon {\n  background: #217346;\n  color: #fff;\n}\n\n.report-step-label {\n  font-size: 14px;\n  color: #333;\n}\n\n.report-step.pending .report-step-label {\n  color: #aaa;\n}\n\n.report-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: reportSpin 0.8s linear infinite;\n}\n\n@keyframes reportSpin {\n  to { transform: rotate(360deg); }\n}\n\n.report-modal-success {\n  padding: 12px 24px 20px;\n  font-size: 14px;\n  color: #217346;\n  font-weight: 500;\n  text-align: center;\n}\n\n.report-modal-error {\n  padding: 12px 24px 20px;\n  font-size: 14px;\n  color: #e74c3c;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.report-modal-retry {\n  background: transparent;\n  border: 1px solid #e74c3c;\n  color: #e74c3c;\n  padding: 6px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.report-modal-retry:hover {\n  background: #e74c3c;\n  color: #fff;\n}\n\n/* Pair mode */\n.detection-item.pair-selected {\n  border-left: 3px solid #2196F3;\n  background: #e3f2fd;\n}\n\n.detection-item.pair-candidate {\n  cursor: pointer;\n}\n\n.detection-item.pair-candidate:hover {\n  background: #e8f4ff;\n}\n\n.detection-item.pair-chosen {\n  background: #e3f2fd;\n  border-left: 3px solid #4CAF50;\n}\n\n.detection-item.pair-dimmed {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.detection-paired-badge {\n  background: #e3f2fd;\n  color: #1565C0;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 4px 2px 6px;\n  border-radius: 8px;\n  white-space: nowrap;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.detection-paired-remove {\n  background: transparent;\n  border: none;\n  color: #90CAF9;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 0 2px;\n  line-height: 1;\n  transition: color 0.15s;\n}\n\n.detection-paired-remove:hover {\n  color: #e74c3c;\n}\n\n.detection-linked-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #2196F3;\n  flex-shrink: 0;\n}\n\n.detection-pair-summary {\n  position: absolute;\n  top: 10px;\n  left: 60px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n}\n\n.detection-pair-confirm {\n  background: #4CAF50;\n  color: #fff;\n  border: none;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.detection-pair-confirm:hover {\n  background: #388E3C;\n}\n\n.detection-pair-cancel {\n  background: transparent;\n  border: none;\n  font-size: 16px;\n  color: #999;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n.detection-pair-cancel:hover {\n  color: #e74c3c;\n}\n\n@media (max-width: 768px) {\n  .detection-split {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* NUBBI-94 — Matches detección ↔ operaciones */\n.detection-filter-bar {\n  display: flex;\n  justify-content: flex-end;\n  padding: 6px 10px;\n  border-bottom: 1px solid #eee;\n  background: #fafafa;\n}\n.detection-filter-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #555;\n  cursor: pointer;\n}\n.detection-filter-toggle input { margin: 0; }\n\n.detection-unmatched-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  background: #e0e0e0;\n  color: #555;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.detection-matches-wrapper {\n  flex-basis: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px dashed #ddd;\n}\n.detection-match-block {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 6px 10px;\n  background: #f1f6ff;\n  border: 1px solid #c9dbf5;\n  border-left: 3px solid #2a5cdb;\n  border-radius: 4px;\n  font-size: 11px;\n}\n.detection-match-block-empty { background: #fafafa; border-color: #eee; border-left-color: #aaa; }\n.detection-match-header { display: flex; align-items: center; gap: 8px; }\n.detection-match-op { font-weight: 600; color: #1a3a8b; }\n.detection-match-page { font-size: 10px; color: #777; }\n.detection-match-params { display: flex; flex-wrap: wrap; gap: 6px 10px; }\n.detection-match-param { display: inline-flex; gap: 4px; color: #444; }\n.detection-match-param-label { color: #888; }\n.detection-match-param-value { font-weight: 500; color: #222; }\n.detection-match-param-highlighted {\n  background: #fff4b8;\n  padding: 1px 6px;\n  border-radius: 3px;\n  font-weight: 700;\n  color: #5a4400;\n}\n.detection-match-param-highlighted .detection-match-param-label { color: #6e5500; }\n.detection-match-param-highlighted .detection-match-param-value { color: #4a3500; }\n\n/* NUBBI-94 — Toggle en pestaña Operaciones */\n.operations-summary-bar {\n  display: flex;\n  justify-content: flex-end;\n  padding: 6px 10px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #eee;\n}\n.operations-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #555;\n  cursor: pointer;\n}\n.operations-toggle input { margin: 0; }\n\n/* NUBBI-94 v2 — Mejora visual sub-bloques matches */\n.detection-item {\n  flex-wrap: wrap;\n  row-gap: 8px;\n}\n\n.detection-unmatched-pill,\n.detection-matched-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  white-space: nowrap;\n}\n.detection-unmatched-pill {\n  background: #f4f4f6;\n  color: #888;\n  border: 1px solid #e3e3e7;\n}\n.detection-unmatched-pill .dot {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #bbb;\n}\n.detection-matched-pill {\n  background: #e7f5ec;\n  color: #1f7a44;\n  border: 1px solid #bfe3cc;\n}\n\n.detection-matches-stack {\n  flex-basis: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 4px 0 4px 24px;\n  padding-left: 12px;\n  border-left: 2px solid #e0e6f2;\n}\n\n.match-card {\n  background: #fbfcfe;\n  border: 1px solid #e4e9f2;\n  border-radius: 6px;\n  padding: 8px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transition: border-color 0.15s ease;\n}\n.match-card:hover { border-color: #b8c5dc; }\n.match-card-empty { background: #fafafa; color: #888; }\n\n.match-card-header {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  font-size: 11px;\n}\n.match-category {\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: #2a5cdb;\n  font-size: 11px;\n}\n.match-subpath { color: #6a7796; font-weight: 500; font-size: 11px; }\n.match-index {\n  margin-left: auto;\n  color: #98a2b8;\n  font-size: 10px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  background: #eef1f7;\n  padding: 1px 6px;\n  border-radius: 8px;\n}\n\n.match-card-params {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));\n  gap: 6px;\n}\n.match-param-chip {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 5px 8px;\n  background: #ffffff;\n  border: 1px solid #e8ecf3;\n  border-radius: 4px;\n  min-width: 0;\n}\n.match-param-key {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  color: #8a93a8;\n  font-weight: 600;\n}\n.match-param-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1f2e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.match-param-chip.is-highlighted {\n  background: linear-gradient(180deg, #fff7c2 0%, #ffefa0 100%);\n  border-color: #f0d564;\n  box-shadow: 0 1px 2px rgba(214, 178, 22, 0.18);\n}\n.match-param-chip.is-highlighted .match-param-key { color: #7c5a00; }\n.match-param-chip.is-highlighted .match-param-value { color: #463100; }\n\n/* NUBBI-94 — Edición manual de matches */\n.detection-assign-btn,\n.detection-edit-match-btn,\n.detection-clear-override-btn {\n  background: none;\n  border: 1px solid #d4d9e3;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 11px;\n  cursor: pointer;\n  color: #4a5470;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n.detection-assign-btn:hover,\n.detection-edit-match-btn:hover,\n.detection-clear-override-btn:hover {\n  background: #f1f5fb;\n  border-color: #2a5cdb;\n  color: #2a5cdb;\n}\n.detection-match-editor-wrapper {\n  flex-basis: 100%;\n  margin-top: 6px;\n}\n.match-editor {\n  background: #fff;\n  border: 1px solid #b8c5dc;\n  border-radius: 6px;\n  padding: 12px;\n  box-shadow: 0 2px 6px rgba(30, 60, 120, 0.08);\n}\n.match-editor-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.match-editor-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 11px;\n  color: #5a6580;\n}\n.match-editor-field > span {\n  text-transform: uppercase;\n  font-size: 10px;\n  letter-spacing: 0.4px;\n  font-weight: 600;\n  color: #6e7891;\n}\n.match-editor-field select {\n  padding: 5px 8px;\n  border: 1px solid #d4d9e3;\n  border-radius: 4px;\n  background: #fafbfd;\n  font-size: 12px;\n  color: #1a1f2e;\n  cursor: pointer;\n}\n.match-editor-field select:focus {\n  outline: none;\n  border-color: #2a5cdb;\n  background: white;\n}\n.match-editor-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n.match-editor-save,\n.match-editor-cancel {\n  padding: 6px 14px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n.match-editor-save { background: #2a5cdb; color: white; }\n.match-editor-save:hover:not(:disabled) { background: #1a4cc0; }\n.match-editor-save:disabled { background: #c0c8d8; cursor: not-allowed; }\n.match-editor-cancel { background: white; color: #5a6580; border-color: #d4d9e3; }\n.match-editor-cancel:hover { background: #f1f5fb; color: #2a5cdb; }\n\n/* NUBBI-94 — Editor formulario (rev) */\n.match-editor-headrow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.match-editor-divider {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0 6px 0;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #8a93a8;\n  font-weight: 600;\n}\n.match-editor-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #e4e9f2;\n}\n.match-editor-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 8px;\n  margin-bottom: 12px;\n}\n.match-editor-field input[type=\"text\"],\n.match-editor-field input[type=\"number\"] {\n  padding: 5px 8px;\n  border: 1px solid #d4d9e3;\n  border-radius: 4px;\n  background: #fff;\n  font-size: 12px;\n  color: #1a1f2e;\n}\n.match-editor-field input:focus {\n  outline: none;\n  border-color: #2a5cdb;\n}\n.match-editor-field.is-auto input {\n  background: linear-gradient(180deg, #fff7c2 0%, #ffefa0 100%);\n  border-color: #f0d564;\n  font-weight: 600;\n}\n.match-editor-field.is-auto > span {\n  color: #7c5a00;\n}\n.match-editor-field input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin: 4px 0;\n}\n\n/* NUBBI-94 — Click en card + X rechazar match */\n.match-card.is-clickable { cursor: pointer; }\n.match-card.is-clickable:hover {\n  border-color: #2a5cdb;\n  box-shadow: 0 2px 5px rgba(42, 92, 219, 0.15);\n}\n.match-card-header { position: relative; }\n.match-card-close {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid #d4d9e3;\n  background: #fff;\n  color: #888;\n  font-size: 12px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n.match-card-close:hover {\n  background: #fee;\n  border-color: #d44;\n  color: #c33;\n}\n\n/* NUBBI-94 — Autosave indicator */\n.detection-autosave-status {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 12px;\n  white-space: nowrap;\n  min-width: 90px;\n  text-align: center;\n  letter-spacing: 0.2px;\n}\n.detection-autosave-status.status-saving { color: #1976d2; background: #e3f2fd; }\n.detection-autosave-status.status-ok { color: #2e7d32; background: #e8f5e9; }\n.detection-autosave-status.status-dirty { color: #b26a00; background: #fff4e0; }\n.detection-autosave-status.status-error { color: #c33; background: #fee; cursor: default; }\n.detection-autosave-status.status-idle { display: none; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
